export default __webpack_public_path__ + "static/media/loading.529c030e.svg";